var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone-Sheet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "000_PhoneSheet",
    transform: "translate(-35.000000, -145.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5,19 L21,19 L21,15.5 C21,15.224 20.777,15 20.5,15 L19.5,15 C19.224,15 19,15.224 19,15.5 L19,19 L15.5,19 C15.224,19 15,19.224 15,19.5 L15,20.5 C15,20.776 15.224,21 15.5,21 L19,21 L19,24.5 C19,24.776 19.224,25 19.5,25 L20.5,25 C20.777,25 21,24.776 21,24.5 L21,21 L24.5,21 C24.777,21 25,20.776 25,20.5 L25,19.5 C25,19.224 24.777,19 24.5,19 Z",
    id: "Page-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8f64e9231e625602ddab980bc7408c6a.svg";
export { ForwardRef as ReactComponent };